import { FC, Fragment, useState } from 'react';
import { DynTransfer, TransferView } from 'ts/dynamic/interfaces/DynamicTransferUpsell';
import { formatPriceDynamic, getTransferValue } from 'utils/dynamic/dynamic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faSuitcase, faUser } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { imgsCar } from 'constants/generic';

interface TransferCardProps {
  transfer: DynTransfer;
  onClickChange: (id?: string) => void;
  isLoading?: boolean;
  selectedTransfer?: DynTransfer;
}

const TransferCard: FC<TransferCardProps> = ({ transfer, ...props }) => {
  const { t } = useTranslation();
  const [item] = useState<TransferView | undefined>(getTransferValue(transfer));
  const selectedItem = getTransferValue(props.selectedTransfer);
  const isSelected = props.selectedTransfer?.priceKey === item?.priceKey;

  return (
    <Fragment>
      {!!item && (
        <div className={'default-shadow dyn-transfer-card' + (isSelected ? ' ticket-choosen' : '')}>
          <div className="dyn-transfer-card-img">
            {<img src={item.code <= imgsCar.length ? imgsCar[item.code] : imgsCar[0]} alt="car" />}
          </div>
          <div className="dyn-transfer-card-data">
            <div className="card-title">{item.desc}</div>
            <div className="card-data">
              <div className="card-data-item">
                <FontAwesomeIcon icon={faUser} />
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('transfer.max_people', {
                      count: item.maxPassengers,
                    }),
                  }}
                ></div>
              </div>
              <div className="card-data-item">
                <FontAwesomeIcon icon={faSuitcase} />
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('transfer.max_suitcases', {
                      count: item.maxLuggage,
                    }),
                  }}
                ></div>
              </div>
              <div className="card-data-item">
                <FontAwesomeIcon icon={faClock} />
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('transfer.est_time', {
                      h:
                        item.duration / 60 >= 1
                          ? Math.floor(item.duration / 60) + t('hours_sm')
                          : '',
                      min: Math.ceil(item.duration % 60) + t('minutes_sm'),
                    }),
                  }}
                ></div>
              </div>
            </div>
          </div>
          <div className="dyn-transfer-card-info flex-center">
            <Fragment>
              <div className="text-light text-center mb-5">{t('dyn.extra_money')}</div>
              <div className="text-bold text-md mb-10">
                {formatPriceDynamic(
                  item.pricePerPerson - (selectedItem?.pricePerPerson || 0),
                  item.currencySign
                )}
              </div>
            </Fragment>
            {isSelected ? (
              <Button
                title={t('cancel')}
                onClick={() => props.onClickChange(item.priceKey)}
                disabled={props.isLoading}
                className="btn btn-default"
              />
            ) : (
              <Button
                title={t('choose')}
                onClick={() => props.onClickChange(item.priceKey)}
                disabled={props.isLoading}
                className="btn btn-primary"
              />
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(TransferCard, 'TransferCard');
